import {useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {initialValuesSponsorForm} from './type';
import {sponsorFormSchema} from './validationSchema';
import MessageCountBottomSheet from '../components/SponsorBottomSheet/SponseringPackageBottomSheet';
import CategoryBottomSheet from '../components/SponsorBottomSheet/TypeBottomSheet';
import OptionalInformation from '../components/OptionalInformation';
import {useParams} from 'react-router-dom';
import usePostSponsor from '../../../services/hookService/sponsor/postSponsor/usePostSponsor';
import useGetSponsorDetail from '../../../services/hookService/sponsor/useGetSponsorDetail/useGetSponsorDetail';
import useGetInitialSponsorInformation from '../../../services/hookService/sponsor/getInitialSponsorInformation/useGetInitialSponsorInformation';
import convertNumberToPersianUnits from '../../../utilities/helper/unitConvertor/convertNumberToPersianUnit';
import usePatchSponsor from '../../../services/hookService/sponsor/usePatchSponsor/usePatchSponsor';
import DotsLoading from '../../../components/dotsLoading';
import SponsorHeader from '../components/header';
import SponsorHeaderText from '../components/SponsorHeaderText';
import CreatePlanForm from '../components/CreatePlanForm';
import SponsorCustomButton from '../components/CustomButton';

export const dataFormInitial = {
  sponsering_package: {
    title: '',
    id: null,
  },
  type: {
    title: '',
    id: null,
  },
  text: '',
  link: '',
  price: 0,
  product: [],
  state: [],
  city: [],
  water_system: [],
  ipg_type: '',
};

const CreateActivePlan = () => {
  const {planId} = useParams();
  const {sponsorInfo, isLoading} = useGetInitialSponsorInformation();
  const {sponsorDetail, isLoading: isLoadingSponsor} = useGetSponsorDetail(
    planId || '',
  );

  const [dataForm, setDataForm] =
    useState<initialValuesSponsorForm>(dataFormInitial);
  const [isShowMessageCountItems, setIsShowMessageCountItems] =
    useState<boolean>(false);
  const [isShowCategoryItems, setIsShowCategoryItems] =
    useState<boolean>(false);
  const [isShowOptionalInformationPage, setIsShowOptionalInformationPage] =
    useState<boolean>(false);
  const {mutate} = usePostSponsor();
  const {patchPlan} = usePatchSponsor();
  useEffect(() => {
    if (!planId || !sponsorDetail || !sponsorInfo) return;

    const oldProducts = sponsorDetail?.product?.map(item => ({
      id: item.id,
      title: item.title,
    }));

    const oldState = sponsorDetail?.state?.map(item => ({
      id: item.id,
      title: item.name,
    }));

    const oldCity = sponsorDetail?.city?.map(item => ({
      id: item.id,
      title: item.name,
    }));

    const oldWaterSystem = sponsorDetail?.water_system?.map(item => ({
      id: item.id,
      title: item.title,
    }));
    setDataForm({
      sponsering_package: {
        title:
          convertNumberToPersianUnits(
            sponsorDetail.sponsoring_message_unit.notification_count,
          ) + ' پیام',
        id: sponsorDetail.sponsoring_message_unit.id,
      },
      type: {
        title:
          sponsorInfo?.type[
            sponsorDetail.notification_type as keyof typeof sponsorInfo.type
          ] || '',
        id: sponsorDetail.notification_type,
      },
      text: sponsorDetail.text,
      link: sponsorDetail.link,
      price: +sponsorDetail.price / 10,
      product: oldProducts || [],
      state: oldState || [],
      city: oldCity || [],
      water_system: oldWaterSystem || [],
      ipg_type: sponsorInfo?.ipg_type || '',
    });
  }, [planId, sponsorDetail, sponsorInfo]);
  const selectFunctionHandler = (values: initialValuesSponsorForm) => {
    const convertFormateData = {
      sponsoring_message_unit: values.sponsering_package.id as number,
      product: values.product.map(item => item.id),
      city: values.city.map(item => item.id),
      state: values.state.map(item => item.id),
      text: values.text,
      link: values.link,
      price: (values.price as number) * 10,
      notification_type: values.type.id,
      ipg_type: values.ipg_type,
      water_system: values.water_system.map(item => item.id),
    };
    if (planId) {
      return patchPlan({
        payload: convertFormateData as PostSponsorPayload,
        guid: planId,
      });
    } else {
      return mutate(convertFormateData as PostSponsorPayload, {
        onSuccess: data => {
          localStorage.setItem('sponsorForm', JSON.stringify(values));
          window.location.replace(data.ipg_url);
        },
      });
    }
  };
  useEffect(() => {
    const savedData = localStorage.getItem('sponsorForm');
    if (savedData) {
      setDataForm(JSON.parse(savedData));
    }
  }, []);
  return (
    <div className="flex flex-col h-[100dvh] bg-white w-full text-gray-800 text-sm relative">
      {(isLoading || isLoadingSponsor) && (
        <div className="w-full h-full absolute z-50 top-0 left-0 flex justify-center items-center bg-[#0000001a]">
          <DotsLoading />
        </div>
      )}
      <SponsorHeader title="حامی مالی" />
      <div className="h-[calc(100dvh-57px)] flex flex-col gap-6 pt-6 pb-8">
        {/* start text */}
        <div className="px-8">
          <SponsorHeaderText />
        </div>
        {/* end text */}
        <Formik
          initialValues={dataForm}
          validationSchema={sponsorFormSchema}
          validateOnMount={false}
          onSubmit={selectFunctionHandler}
          enableReinitialize={true}
        >
          {() => (
            <>
              <Form className="h-full flex flex-col gap-6 justify-between overflow-y-scroll no-scrollbar">
                {/* start create plan */}
                <CreatePlanForm
                  isEdit={!!planId}
                  setIsShowMessageCountItems={setIsShowMessageCountItems}
                  setIsShowCategoryItems={setIsShowCategoryItems}
                  setIsShowOptionalInformationPage={
                    setIsShowOptionalInformationPage
                  }
                />
                {/* end create plan */}
                {/* start link new plan */}
                <div className="px-8">
                  <SponsorCustomButton
                    outline={false}
                    buttonType="submit"
                    title={planId ? 'ثبت' : 'تأیید و پرداخت'}
                  />
                </div>
                {/* end link new plan */}
              </Form>
              <MessageCountBottomSheet
                show={isShowMessageCountItems}
                setShow={setIsShowMessageCountItems}
              />
              <CategoryBottomSheet
                show={isShowCategoryItems}
                setShow={setIsShowCategoryItems}
              />
              <OptionalInformation
                isShowOptionalInformationPage={isShowOptionalInformationPage}
                setIsShowOptionalInformationPage={
                  setIsShowOptionalInformationPage
                }
              />
            </>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CreateActivePlan;
